(()=>{
 'use strict';
 const config=JSON.parse(document.getElementById('themeConfig')?.textContent||'{}');
 const toast=document.getElementById('themeToast');let timer;
 const notify=s=>{if(!toast)return;toast.textContent=s;toast.hidden=false;clearTimeout(timer);timer=setTimeout(()=>toast.hidden=true,4500);};
 const read=()=>{try{const raw=JSON.parse(localStorage.getItem('frizideri.theme.compare')||'[]');return Array.isArray(raw)?[...new Set(raw.filter(x=>/^\d+$/.test(x)))].slice(0,3):[];}catch{return[];}};
 let compare=read();
 const menu=document.getElementById('menuToggle');
 menu?.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));document.getElementById('mainNav')?.classList.toggle('open',open);});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'){menu?.setAttribute('aria-expanded','false');document.getElementById('mainNav')?.classList.remove('open');}});
 function comparison(){
  try{localStorage.setItem('frizideri.theme.compare',JSON.stringify(compare));}catch{}
  document.querySelectorAll('[data-native-compare]').forEach(el=>el.checked=compare.includes(el.dataset.nativeCompare));
  const rows=[...document.querySelectorAll('[data-native-compare-row]')];
  const present=compare.filter(id=>rows.some(r=>r.dataset.nativeCompareRow===id));
  rows.forEach((r,i)=>r.hidden=present.length?!present.includes(r.dataset.nativeCompareRow):i>2);
 }
 document.addEventListener('change',e=>{
  const el=e.target;
  if(el.matches('[data-native-compare]')){
   const id=el.dataset.nativeCompare;
   if(el.checked){if(compare.length===3){el.checked=false;notify(config.compareMax);return;}compare.push(id);}else compare=compare.filter(x=>x!==id);
   comparison();
  }
  if(el.matches('[data-native-variant]')){
   const opt=el.selectedOptions[0];
   ['nativePrice','nativeStickyPrice'].forEach(id=>{const p=document.getElementById(id);if(p)p.textContent=opt.dataset.price;});
   document.querySelectorAll('[data-product-submit]').forEach(b=>b.disabled=opt.dataset.available!=='true');
  }
 });
 document.addEventListener('click',e=>{
  const b=e.target.closest('button');if(!b)return;
  if(b.dataset.nativeGallery){const image=document.querySelector('#nativeGallery img');if(image){image.src=b.dataset.nativeGallery;image.removeAttribute('srcset');image.alt=b.dataset.alt;}document.querySelectorAll('[data-native-gallery]').forEach(el=>el.setAttribute('aria-pressed',String(el===b)));}
  if(b.dataset.nativeStep){const input=b.closest('.quantity').querySelector('input');input.value=Math.min(20,Math.max(1,Number(input.value||1)+Number(b.dataset.nativeStep)));}
 });
 const grid=document.getElementById('nativeGrid');
 if(grid){
  const cards=[...grid.querySelectorAll('[data-native-card]')];cards.forEach((c,i)=>c.dataset.order=i);
  const search=document.getElementById('nativeSearch'),sort=document.getElementById('nativeSort');
  let category=new URLSearchParams(location.search).get('category')||'all';
  if(!['all','ready','xxl','standard','mini','double'].includes(category))category='all';
  const norm=s=>s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  function filter(){
   const q=norm(search.value);let count=0;
   cards.forEach(c=>{c.hidden=!(norm(c.dataset.name).includes(q)&&(category==='all'||c.dataset.category===category));if(!c.hidden)count++;});
   const ordered=cards.slice().sort((a,b)=>sort.value==='asc'?Number(a.dataset.price)-Number(b.dataset.price):sort.value==='desc'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.order)-Number(b.dataset.order));ordered.forEach(c=>grid.append(c));
   document.querySelectorAll('[data-native-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.nativeFilter===category)));
   const empty=document.getElementById('nativeEmpty');if(empty)empty.hidden=!!count;
  }
  search.addEventListener('input',filter);sort.addEventListener('change',filter);
  document.querySelectorAll('[data-native-filter]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.nativeFilter;filter();}));filter();
 }
 comparison();
})();
